import { put, call, takeLatest } from 'redux-saga/effects';
import {
    dashboardLoad,
    dashboardSuccess,
    dashboardFailed,
    signupsLoad,
    signupsSuccess,
    signupsFailed,
    topUsageLoad,
    topUsageSuccess,
    topUsageFailed,
    moodsLoggedLoad,
    moodsLoggedSuccess,
    moodsLoggedFailed,
    thoughtsLoggedLoad,
    thoughtsLoggedSuccess,
    thoughtsLoggedFailed,
    postActivityLoad,
    postActivitySuccess,
    postActivityFailed,
    wellnessActivityLoad,
    wellnessActivitySuccess,
    wellnessActivityFail,
    averageMoodLoad,
    averageMoodSuccess,
    averageMoodFail,
    wellnessChartLoad,
    wellnessChartSuccess,
    wellnessChartFail,
    getWhoScoreLoad,
    getWhoScoreSuccess,
    getWhoScoreFail,
    requestScoreLoad,
    requestScoreSuccess,
    editrequestScoreLoad,
    requestScoreFail,
    getAffirmationLoad,
    getTherapyload,
    getJournalLoad,
    getAffirmationSuccess,
    getTherapySuccess,
    getJournalSuccess,
    upcomingAssessmentLoad,
    upcomingAssessmentFail,
    upcomingAssessmentSuccess,
} from '../slices/dash.slice';
import {
    dashboardApi,
    moodsLoogedApi,
    postActivityApi,
    thoughtsLoggedApi,
    topUsageApi,
    SignupsApi,
    wellnesActivityApi,
    averageMoodsApi,
    wellnessChartApi,
    getWhoScoreApi,
    RequestScoreApoi,
    editRequestScoreApoi,
    getAffirmationApi,
    getTherapyApi,
    getJournalApi,
    upcomingAssessmentApi,
} from '../Api/api';
import { navigate } from '../../common/navigator'
import { toast } from 'react-toastify';
import appconstant from '../../themes/appconstant';

function* dashboardSaga(action) {
    try {
        const data = yield call(dashboardApi, action.payload);
        if (data.status === 0) {
            yield put(dashboardSuccess(data.result));
        } else if (data.status === 2) {
            localStorage.clear();
            navigate('/login');
        } else {
            toast.error(data?.result?.message)

            yield put(dashboardFailed());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(dashboardFailed());
    }
}

function* signUpsSaga(action) {
    try {
        const data = yield call(SignupsApi, action.payload);
        if (data.status === 0) {
            yield put(signupsSuccess(data.result));
        } else if (data.status === 2) {
            localStorage.clear();
        } else {
            toast.error(data?.result?.message)

            yield put(signupsFailed());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(signupsFailed());
    }
}

function* topUsageSaga(action) {
    try {
        const data = yield call(topUsageApi, action.payload);
        if (data.status === 0) {
            yield put(topUsageSuccess(data.result));
        } else if (data.status === 2) {
            localStorage.clear();
        } else {
            toast.error(data?.result?.message)

            yield put(topUsageFailed());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(topUsageFailed());
    }
}

function* moodsLoogedSaga(action) {
    try {
        const data = yield call(moodsLoogedApi, action.payload);
        if (data.status === 0) {
            yield put(moodsLoggedSuccess(data.result));
        } else if (data.status === 2) {
            localStorage.clear();
        } else {
            toast.error(data?.result?.message)

            yield put(moodsLoggedFailed());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(moodsLoggedFailed());
    }
}

function* thoughtsLoggedSaga(action) {
    try {
        const data = yield call(thoughtsLoggedApi, action.payload);
        if (data.status === 0) {
            yield put(thoughtsLoggedSuccess(data.result));
        } else if (data.status === 2) {
            localStorage.clear();
        } else {
            toast.error(data?.result?.message)

            yield put(thoughtsLoggedFailed());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(thoughtsLoggedFailed());
    }
}

function* postActivitySaga(action) {
    try {
        const data = yield call(postActivityApi, action.payload);
        if (data.status === 0) {
            yield put(postActivitySuccess(data.result));
        } else {
            toast.error(data?.result?.message)

            yield put(postActivityFailed());
        }
    } catch (e) {
        toast.error(appconstant.serverError);
        yield put(postActivityFailed());
    }
}

function* wellnessActivitySaga(action) {
    try {
        const data = yield call(wellnesActivityApi, action.payload);

        if (data.status === 0) {
            yield put(wellnessActivitySuccess(data.result));
        } else {
            toast.error(data?.result?.message)

            yield put(wellnessActivityFail());
        }
    } catch (e) {
        toast.error(appconstant.serverError);


        yield put(wellnessActivityFail());
    }
}

function* averageMoodSaga(action) {
    try {

        const data = yield call(averageMoodsApi, action.payload);
        if (data.status === 0) {
            yield put(averageMoodSuccess(data.result));
        } else {
            toast.error(data?.result?.message)

            yield put(averageMoodFail());
        }
    } catch (e) {
        toast.error(appconstant.serverError);

        yield put(averageMoodFail());
    }
}

function* wellnessChartSaga(action) {
    try {
        const data = yield call(wellnessChartApi, action.payload);
        if (data.status === 0) {
            yield put(wellnessChartSuccess(data.result.data));
        } else {
            toast.error(data?.result?.message)

            yield put(wellnessChartFail());
        }
    } catch (e) {
        toast.error(appconstant.serverError);

        yield put(wellnessChartFail());
    }

}

function* whoScoreSaga(action) {
    try {
        const data = yield call(getWhoScoreApi, action.payload);
        if (data.status === 0) {
            console.log("sdfsfdsf", data.result.data);
            yield put(getWhoScoreSuccess(data.result.data));
        } else {
            toast.error(data?.result?.message)

            yield put(getWhoScoreFail());
        }
    } catch (e) {
        toast.error(appconstant.serverError);

        yield put(getWhoScoreFail());
    }
}

function* requestScoreSaga(action) {
    try {
        const data = yield call(RequestScoreApoi, action.payload);
        if (data.status === 0) {
            yield put(requestScoreSuccess(data.result.data));
            yield put(upcomingAssessmentLoad({ organisation: action.payload.organisation }));

        }
        else {
            yield put(requestScoreFail());
            toast.error(data?.result?.message)
        }
    }
    catch (e) {
        yield put(requestScoreFail());
        toast.error(appconstant.serverError);

    }
}
function* editRequestScoreSaga(action) {
    try {
        const data = yield call(editRequestScoreApoi, action.payload);
        if (data.status === 0) {
            toast.success(data?.result?.message)
            yield put(requestScoreSuccess(data.result.data));
        }
        else {
            yield put(requestScoreFail());
            toast.error(data?.result?.message)
        }
    }
    catch (e) {
        yield put(requestScoreFail());
        toast.error(appconstant.serverError);

    }
}

function* affirmationSaga(action) {

    try {
        const data = yield call(getAffirmationApi, action.payload);
        if (data.status === 0) {

            yield put(getAffirmationSuccess(data.result?.data));
        }
        else {
            toast.error(data?.result?.message)
        }
    }
    catch (e) {
        toast.error(appconstant.serverError);
    }
}

function* therapySaga(action) {

    try {
        const data = yield call(getTherapyApi, action.payload);
        if (data.status === 0) {

            yield put(getTherapySuccess(data.result?.data));
        }
        else {
            toast.error(data?.result?.message)
        }
    }
    catch (e) {
        toast.error(appconstant.serverError);
    }
}

function* journalSaga(action) {
    try {
        const data = yield call(getJournalApi, action.payload);
        if (data.status === 0) {
            yield put(getJournalSuccess(data.result?.data));
        }
        else {
            toast.error(data?.result?.message)
        }
    }
    catch (e) {
        toast.error(appconstant.serverError);
    }
}

function* upcomingAssessmentSaga(action) {
    try {
        const data = yield call(upcomingAssessmentApi, action.payload);
        if (data.status === 0) {
            yield put(upcomingAssessmentSuccess(data.result.data));
        }
        else {
            yield put(upcomingAssessmentFail(data.result.data));
            toast.error(data?.result?.message)
        }
    }
    catch (e) {
        toast.error(appconstant.serverError);
        yield put(upcomingAssessmentFail());
    }
}

export default function* rootDashboardSaga() {
    yield takeLatest(dashboardLoad.type, dashboardSaga);
    yield takeLatest(signupsLoad.type, signUpsSaga);
    yield takeLatest(topUsageLoad.type, topUsageSaga);
    yield takeLatest(moodsLoggedLoad.type, moodsLoogedSaga);
    yield takeLatest(thoughtsLoggedLoad.type, thoughtsLoggedSaga);
    yield takeLatest(postActivityLoad.type, postActivitySaga);
    yield takeLatest(wellnessActivityLoad.type, wellnessActivitySaga);
    yield takeLatest(averageMoodLoad.type, averageMoodSaga);
    yield takeLatest(wellnessChartLoad.type, wellnessChartSaga);
    yield takeLatest(getWhoScoreLoad.type, whoScoreSaga);
    yield takeLatest(requestScoreLoad.type, requestScoreSaga);
    yield takeLatest(editrequestScoreLoad.type, editRequestScoreSaga);
    yield takeLatest(getAffirmationLoad.type, affirmationSaga);
    yield takeLatest(getTherapyload.type, therapySaga);
    yield takeLatest(getJournalLoad.type, journalSaga);
    yield takeLatest(upcomingAssessmentLoad.type, upcomingAssessmentSaga);
}
